export const API_URL = 'https://api.almouj.sensoreal.com.au/api/';
export const ASSETS_HOST = 'https://assets.almouj.sensoreal.com.au/';
export const FAVOURITES_HOST = "https://favourites.almouj.sensoreal.com.au/"
export default API_URL;
